import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {StepperSelectionEvent} from '@angular/cdk/stepper';
import {Router} from '@angular/router';
import {RegisterkadeckwebService} from '../services/registerkadeckweb.service';

@Component({
  selector: 'app-webregistration',
  templateUrl: './webregistration.component.html',
  styleUrls: ['./webregistration.component.scss', '../registration/registration.component.scss']
})
export class WebregistrationComponent implements OnInit {

  @Output()
  isProcessing = new EventEmitter();

  teamFormGroup: FormGroup;
  personalInfoFormGroup: FormGroup;

  accepteula = new FormControl(false, Validators.requiredTrue);
  newsletter = new FormControl(false);
  editable = true;
  statusmessage = "Creating your account. Please wait..";
  status: 'success' | 'loading' | 'failure' | 'none' = 'loading';

  constructor(private formBuilder: FormBuilder, private router: Router, private registerkadeckwebService: RegisterkadeckwebService) {}

  ngOnInit() {
    this.teamFormGroup = this.formBuilder.group({
      teamname: ['', [Validators.required, Validators.minLength(5)]]
    });

    this.personalInfoFormGroup = this.formBuilder.group({
      name: ['', Validators.required],
      company: ['', Validators.required],
      phone: [''],
      email: ['', [Validators.required, Validators.email]],
      accepteula: this.accepteula,
      newsletter: this.newsletter
    });
  }

  onStepperChanged(stepperSelectionEvent: StepperSelectionEvent) {
    if (stepperSelectionEvent.selectedIndex === 2){
      this.isProcessing.emit(true);
      this.editable = false;
      this.status = 'loading';

      let teamname = this.teamFormGroup.get("teamname").value;
      let company = this.personalInfoFormGroup.get("company").value;
      let name = this.personalInfoFormGroup.get("name").value;
      let email = this.personalInfoFormGroup.get("email").value;
      let phone = this.personalInfoFormGroup.get("phone").value;
      let newsletter = this.personalInfoFormGroup.get("newsletter").value;

      this.registerkadeckwebService.register(teamname, name, company, phone, email, newsletter)
        .subscribe(value => {
            if (value['errorMessage']) {
              console.log('Error', value);
              this.status = 'failure';
              this.statusmessage = value['errorMessage'];
              return;
            }

            if (value["statusCode"] !== 200){
              this.status = 'failure';
              this.statusmessage = value["body"];
              return;
            }


            console.log('Success', value);
            this.status = 'success';
            this.statusmessage = 'Success! Please confirm your email address.';
            this.router.navigate(['thankyou']);

          },
          error => {
            console.log('Error', error);
            this.status = 'failure';
            this.statusmessage = 'Failed: ' + error.msg;
          });
    }
  }
}
